import script from "./EntryDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./EntryDetails.vue?vue&type=script&setup=true&lang=ts"

import "./EntryDetails.vue?vue&type=style&index=0&id=3400b3b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3400b3b4"]])

export default __exports__